import {compose, withHandlers} from 'recompose'
import {connect} from 'react-redux'

import {addAWeek} from '../utils/calendarUtils'
import {setSelectedDate} from '../../../redux/modules/date'
import CalendarDayListNextButton from '../components/CalendarDayListNextButton'

const mapStateToProps = (state) => ({
  selectedDate: state.date.selectedDate,
})

const mapDispatchToProps = {
  setSelectedDate,
}

const NextWeekButtonContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onClick:
      ({selectedDate, setSelectedDate}) =>
      () =>
        setSelectedDate(addAWeek(selectedDate)),
  }),
)(CalendarDayListNextButton)

export default NextWeekButtonContainer
